<template>
    <section class="app-container">
      <!-- 工具条 -->
      <!-- <toolbar :button-list="buttonList" @handleAdd="handleAdd" @handleQuery="handleQuery"/> -->
      <el-button type="primary" @click="handleAdd" style="margin-bottom:15px">新增兵种</el-button>

      <!-- 列表 -->
      <el-table
        :data="list"
        v-loading="listLoading"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%"
      >
        <el-table-column prop="Code" label="兵种编码" width="200"/>
        <el-table-column prop="Name" label="兵种名称"/>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.Id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        layout="total, prev, pager, next"
        :current-page="page"
        :page-size="20"
        :total="total"
        @current-change="handlePageChange"
      />
  
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" :rules="editFormRules" ref="editForm">
          <el-form-item label="兵种编码" prop="Code">
            <el-input v-model="editForm.Code" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="兵种名称" prop="Name">
            <el-input v-model="editForm.Name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>
  
      <!-- 新增界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" :rules="addFormRules" ref="addForm">
          <el-form-item label="兵种编码" prop="Code">
            <el-input v-model="addForm.Code"></el-input>
          </el-form-item>
          <el-form-item label="兵种名称" prop="Name">
            <el-input v-model="addForm.Name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </template>
  
  <script>
  import { 
    getArmyTypeList,
    addArmyType,
    updateArmyType,
    deleteArmyType
  } from '@/api/api'
  
  export default {
    data() {
      return {
        buttonList: ['add'],
        list: [],
        total: 0,
        page: 1,
        listLoading: false,
        currentRow: null,
  
        // 编辑相关
        editFormVisible: false,
        editLoading: false,
        editFormRules: {
          Code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        },
        editForm: {
          Id: '',
          Code: '',
          Name: ''
        },
  
        // 新增相关
        addFormVisible: false,
        addLoading: false,
        addFormRules: {
          Code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        },
        addForm: {
          Code: '',
          Name: ''
        }
      }
    },
    methods: {
        // 获取列表
        handleQuery() {
            this.listLoading = true
            getArmyTypeList({
            page: this.page,
            pageSize: 20 // 与分页组件保持一致
            }).then(res => {
            const response = res.data.response
            this.list = response.data
            this.total = response.dataCount
            this.listLoading = false
            })
        },
  
      // 分页切换
      handlePageChange(val) {
        this.page = val
        this.handleQuery()
      },
  
      // 选中行
      handleCurrentChange(val) {
        this.currentRow = val
      },
  
      // 显示编辑界面
      handleEdit(row) {
        this.editForm = Object.assign({}, row)
        this.editFormVisible = true
      },
  
      // 提交编辑
      editSubmit() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.editLoading = true
            updateArmyType(this.editForm).then(res => {
              this.editLoading = false
              if (res.data.success) {
                this.$message.success('更新成功')
                this.handleQuery()
                this.editFormVisible = false
              }
            })
          }
        })
      },
  
      // 显示新增界面
      handleAdd() {
        this.addFormVisible = true
        this.addForm = { Code: '', Name: '' }
      },
  
      // 提交新增
      addSubmit() {
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.addLoading = true
            addArmyType(this.addForm).then(res => {
              this.addLoading = false
              if (res.data.success) {
                this.$message.success('添加成功')
                this.handleQuery()
                this.addFormVisible = false
              }
            })
          }
        })
      },
  
      // 删除
      handleDelete(id) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          deleteArmyType(id).then(res => {
            if (res.data.success) {
              this.$message.success('删除成功')
              this.handleQuery()
            }
          })
        })
      }
    },
    mounted() {
      this.handleQuery()
    }
  }
  </script>